import { render, staticRenderFns } from "./payfor-edit.vue?vue&type=template&id=5c57ac66"
import script from "./payfor-edit.vue?vue&type=script&lang=js"
export * from "./payfor-edit.vue?vue&type=script&lang=js"
import style0 from "./payfor-edit.vue?vue&type=style&index=0&id=5c57ac66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports